import React from 'react'
import styled from 'styled-components'

const PanelCurrencyInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-right: 40px;

  /* Tablets */
  @media (max-width: 1400px) {
    margin-left: 0.5em;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    margin-left: 0.5em;
  }
`

export default PanelCurrencyInformation
